import { render, staticRenderFns } from "./PageYear.vue?vue&type=template&id=72d34f4e&"
import script from "./PageYear.vue?vue&type=script&lang=js&"
export * from "./PageYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports